// Permanent URL moves.
//
// help-site has no edge-redirect layer (CloudFront config is provisioned
// out-of-band), so a moved page keeps a real pre-rendered HTML file at its
// OLD path. That file carries `<link rel="canonical">` to the new URL and a
// `<meta http-equiv="refresh">`, and the React route sends live visitors on
// with a client-side replace. Crawlers get the canonical, humans get the
// page, and nobody gets a 404.
//
// This is a stand-in for real 301s. If an edge redirect layer ever lands,
// move these there and delete the routes — the table is the source of truth
// either way.

export interface Redirect {
  /** The old path, exactly as it used to be served. */
  from: string
  /** Where it lives now. */
  to: string
}

/** HQ → Choosie rename. */
export const redirects: Redirect[] = [
  { from: '/hq', to: '/choosie' },
  { from: '/hq/asking-questions', to: '/choosie/asking-questions' },
  { from: '/hq/charts-and-tables', to: '/choosie/charts-and-tables' },
  { from: '/hq/good-prompts', to: '/choosie/good-prompts' },
  { from: '/hq/plans-and-approvals', to: '/choosie/plans-and-approvals' },
  { from: '/hq/what-it-can-do', to: '/choosie/what-it-can-do' },
  {
    from: '/workflows/run-hq-as-coordinator',
    to: '/workflows/run-choosie-as-coordinator',
  },
  /** Plans retired 2026-08 — the ATS is free; the page is now about rate limits. */
  { from: '/reference/plans-and-limits', to: '/reference/usage-limits' },
]
